module.exports = __webpack_public_path__ + "static/media/orange-stories-img-003.9793fe58.jpg";